<template>
  <div class="wrapGridArea">
    <div class="title">Master-Detail 구조 테스트 <span style="font-size:12px; color: #aaa; font-style: italic;">그리드 내에 행을 클릭하면 하단에 데이터가 보여집니다.</span></div>
    <SBGrid
      id="grid"
      style="width: 100%; height: 250px"
      ref="grid"
      :data="gridJson"
      :columns="grid1columns"
      :gridattr="{rowheader: 'seq', rowheadercaption : {seq: '순번'}, rowheaderwidth: {seq: '80'},extendcol: 14,showtotalrows:true}"
      :bind="{click: 'fnGetRowData'}"
    ></SBGrid>

    <div class="detailInfo">
      <div class="title">Detail Information</div>
      <div><span class="detailText">사번</span><input type="text" id="col1" class="detailInput"></div>
      <div><span class="detailText">이름</span><input type="text" id="col2" class="detailInput"></div>
      <div><span class="detailText">이메일</span><input type="text" id="col12" class="detailInput"></div>
      <div><span class="detailText">주소</span><input type="text" id="col14" class="detailInput"></div>
    </div>
  </div>
</template>

<script>
window.selectedRowData;
window.fnGetRowData = function() {
  if( window.vl.$refs.view.$refs.grid.gridObject.getRow() > 1 ){
    window.selectedRowData = window.vl.$refs.view.$refs.grid.gridObject.getRowData(window.vl.$refs.view.$refs.grid.gridObject.getRow());
    document.querySelector("#col1").value = window.selectedRowData.col1;
    document.querySelector("#col2").value = window.selectedRowData.col2;
    document.querySelector("#col12").value = window.selectedRowData.col12;
    document.querySelector("#col14").value = window.selectedRowData.col14;
  }
}
import SBGrid from '../SBGrid.vue'
export default {
  data: function() {
    return {
      gridJson: [
        {"col1": "2010150031","col2": "홍길동","col3": "ko","col4": "1","col5": "20200131","col6": "20200222","col7": 1,"col8": "true","col9": "true","col10": "","col11": "","col12": "cs@softbowl.co.kr","col13": "바로가기","col14": "서울특별시\n금천구\n독산동","col15": ""},
        {"col1": "2010150032","col2": "이현수","col3": "ja","col4": "2","col5": "20200222","col6": "20200327","col7": 1,"col8": "true","col9": "true","col10": "","col11": "","col12": "cas@softbowl.co.kr","col13": "바로가기","col14": "인천광역시 서구","col15": ""},
        {"col1": "2009153021","col2": "Benjamin","col3": "en","col4": "3","col5": "20200131","col6": "20200222","col7": 1,"col8": "true","col9": "true","col10": "","col11": "","col12": "cs@softbowl.co.kr","col13": "바로가기","col14": "6032 California Ave SW Seattle, WA 98136, US","col15": ""},
        {"col1": "2010150032","col2": "이현지","col3": "ko","col4": "1","col5": "20200131","col6": "20200522","col7": 1,"col8": "true","col9": "true","col10": "","col11": "","col12": "zza@softbowl.co.kr","col13": "바로가기","col14": "인천광역시 서구 염곡로","col15": ""},
        {"col1": "2010150033","col2": "최현우","col3": "ja","col4": "2","col5": "20200222","col6": "20200327","col7": 1,"col8": "true","col9": "true","col10": "","col11": "","col12": "884asd@softbowl.co.kr","col13": "바로가기","col14": "인천광역시 서구","col15": ""}
      ],
      grid1columns: [
        {"caption": ["Column Type","사번"],"ref": "col1","width": "80","style": "text-align:center","type": "input"},
        {"caption": ["Column Type","이름"],"ref": "col2","width": "60","style": "text-align:center","type": "output"},
        {"caption": ["Column Type","국적"],"ref": "col3","width": "80","style": "text-align:center","type": "combo","typeinfo": {"ref": [{"label": "한국","value": "ko"},{"label": "일본","value": "ja"},{"label": "중국","value": "ch"},{"label": "미국","value": "en"}],"label": "label","value": "value","oneclickedit": true,"displayui": true}},
        {"caption": ["Column Type","취미"],"ref": "col4","width": "100","style": "text-align:center","type": "inputcombo","typeinfo": {"ref": [{"label": "축구","value": "1"},{"label": "농구","value": "2"},{"label": "배구","value": "3"}],"label": "label","value": "value","oneclickedit": true,"displayui": true,"format": null,"position": "default","itemcount": 0,"unselect": {},"filtering": {},"emptyvalue": false,"listshowcode": false,"listshowcodejointext": " | ","singlelistenterselect": false,}},
        {"caption": ["Column Type","날짜"],"ref": "col5","width": "100","style": "text-align:center","type": "datepicker","typeinfo": {"dateformat": "yymmdd","format": {"type": "date","rule": "YYYY-MM-DD","origin": "YYYY-MM-DD","locale": "ko"},"position": "bottom","locale": "ko","alias": "yyyy-mm-dd","clearbutton": false,"calendartype": "date","yearrange": 10,"mindate": "","maxdate": "",},"format": {"type": "date","rule": "YYYY-MM-DD","origin": "YYYY-MM-DD","locale": "ko"}},
        {"caption": ["Column Type","날짜-입력"],"ref": "col6","width": "100","style": "text-align:center","type": "inputdate","typeinfo": {"dateformat": "yymmdd","oneclickedit": true,"format": {"type": "date","rule": "YYYY-MM-DD","origin": "YYYY-MM-DD","locale": "ko"},"position": "bottom","locale": "ko","alias": "yyyy-mm-dd","clearbutton": true,"calendartype": "date","yearrange": 10,"mindate": "","maxdate": "",},"format": {"type": "date","rule": "YYYY-MM-DD","origin": "YYYY-MM-DD","locale": "ko"}},
        {"caption": ["Column Type","SPINNER"],"ref": "col7","width": "100","style": "text-align:center","type": "spinner"},
        {"caption": ["컬럼타입","CHECKBOX"],"ref": "col8","width": "100","style": "text-align:center","type": "checkbox"},
        {"caption": ["컬럼타입","RADIO"],"ref": "col9","width": "100","style": "text-align:center","type": "radio"},
        {"caption": ["컬럼타입","MULTIRADIO"],"ref": "col10","width": "120","style": "text-align:center","type": "multiradio","typeinfo": {"radiolabel": ["YES","NO"],"radiovalue": ["T","F"],"format": null,}},
        {"caption": ["컬럼타입","BUTTON"],"ref": "col11","width": "100","style": "text-align:center","type": "button","typeinfo": {"buttonvalue": "click","format": null,}},
        {"caption": ["컬럼타입","이메일"],"ref": "col12","width": "150","style": "text-align:center","type": "inputbutton","typeinfo": {"buttonvalue": "click","format": null,"mask": null,"autocomplete": [],"autocompleteinfo": null,"autofillinput": null,}},
        {"caption": ["컬럼타입","OUTPUTBUTTON"],"ref": "col13","width": "150","style": "text-align:center","type": "outputbutton","typeinfo": {"buttonvalue": "click","format": null,}},
        {"caption": ["컬럼타입","TEXTAREA"],"ref": "col14","width": "33","style": "text-align:left;padding-left:30px","type": "textarea"},
        {"caption": ["컬럼타입","IMAGE"],"ref": "col15","width": "80","style": "text-align:center","type": "image","typeinfo": {"imageuri": "./images/lock.png","imagewidth": "30","imageheight": "30","imagestyle": "cursor:pointer","imagealt": "이미지파일입니다","format": null,"ref": "","imageerroruri": "./images/error.png",}}
      ],
    }
  },
  components: {
    SBGrid,
  }
}
</script>

<style>
.detailInfo {
  width: 100%;  
  margin-top: 30px;
}
.detailInfo > span {
  font-size: 15pt;
}
.detailText {
  width: 10%;
  padding: 5px;
  margin: 0px 5px 5px 0px;
  text-align: center;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.detailInput {
  width: 85%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  vertical-align: top;
  transition: 0.3s all;
}
.detailInput:focus {
  outline: none !important; border-color: #8bdeb8; box-shadow: 0 0 10px #ccf7e4; 
}
</style>